import {updateBlockCommand} from '../../../../../api/blockManipulation/commands/updateBlock'
import {InputRule, mergeAttributes} from '@tiptap/core'
import {mergeCSSClasses} from '../../../../../shared/utils'
import {createTipTapBlock} from '../../../api/block'
import {getBlockInfoFromPos} from '../../../helpers/getBlockInfoFromPos'
import styles from '../../Block.module.css'

export const HeadingBlockContent = createTipTapBlock<'heading'>({
  name: 'heading',
  content: 'inline*',

  addAttributes() {
    return {
      level: {
        default: '2',
        // instead of "level" attributes, use "data-level"
        parseHTML: (element) => element.getAttribute('data-level'),
        renderHTML: (attributes) => {
          return {
            'data-level': attributes.level,
          }
        },
      },
      revision: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-revision') || '',
        renderHTML: (attributes) => (attributes.revision ? {'data-revision': attributes.revision} : {}),
      },
    }
  },

  addInputRules() {
    return [
      ...['1', '2', '3', '4', '5'].map((level) => {
        // Creates a heading of appropriate level when starting with "#", "##", or "###".
        return new InputRule({
          find: new RegExp(`^(#{${parseInt(level)}})\\s$`),
          handler: ({state, chain, range}) => {
            // Resolve the nearest enclosing block regardless of nesting depth.
            // The previous `$pos.start() - 2` math only held for paragraphs
            // directly under the top-level blockChildren and silently no-oped
            // when the cursor was inside a nested block.
            const blockInfo = getBlockInfoFromPos(state, state.selection.from)
            chain()
              .command(
                updateBlockCommand(blockInfo.block.beforePos, {
                  type: 'heading',
                  props: {
                    level: level,
                  },
                }),
              )
              .deleteRange({from: range.from, to: range.to})
          },
        })
      }),
    ]
  },

  parseHTML() {
    return [
      {
        tag: 'h1',
        attrs: {level: '1'},
        node: 'heading',
      },
      {
        tag: 'h2',
        attrs: {level: '2'},
        node: 'heading',
      },
      {
        tag: 'h3',
        attrs: {level: '3'},
        node: 'heading',
      },
      {
        tag: 'h4',
        attrs: {level: '3'},
        node: 'heading',
      },
      {
        tag: 'h5',
        attrs: {level: '3'},
        node: 'heading',
      },
    ]
  },

  renderHTML({node, HTMLAttributes}) {
    const blockContentDOMAttributes = this.options.domAttributes?.blockContent || {}
    const inlineContentDOMAttributes = this.options.domAttributes?.inlineContent || {}

    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        class: mergeCSSClasses(
          // @ts-ignore
          styles.blockContent,
          blockContentDOMAttributes.class,
        ),
        'data-content-type': this.name,
      }),
      [
        'h' + node.attrs.level,
        {
          class: mergeCSSClasses(
            // @ts-ignore
            styles.inlineContent,
            inlineContentDOMAttributes.class,
          ),
        },
        0,
      ],
    ]
  },
})
